angular.module('impactx.toolbar').controller('DialogToolbarCtrl', [
    '$scope',
    'sidebarShow',
    'TranslationService',
    'BackService',
    '$window',
    '$timeout',
    '$securityManager',
    DialogToolbarCtrl]);

function DialogToolbarCtrl($scope, sidebarShow, TranslationService, BackService, $window, $timeout, $securityManager) {
    var ctrl = this;

    ctrl.getLabel = function(translationKey) {
        return TranslationService.get(translationKey);
    };

    ctrl.back = function() {
        if ($scope.abortFunction)
        {
            $scope.abortFunction();
        }
        else
        {
            if($scope.abortCallbackFunction) {
                $scope.abortCallbackFunction();
            }
            BackService.back();
        }
    };

    ctrl.sidebarShow = sidebarShow;
    $scope.abortLabel = ctrl.getLabel('back');

    ctrl.toggleAbortLabel = function() {
        $scope.abortLabel = ctrl.getLabel('abort');
    };

    $scope.toolbarButtons = [];
    $scope.dropDownButtons = [];

    var i = 0;
    var buttonDefinitionWatcher = $scope.$watch(function() {
        return typeof $scope.buttonDefinition;
    }, function(newValue, oldValue) {
        if(newValue != oldValue && newValue != "undefined") {
            var noChangedCondition = false;
            while(i < $scope.buttonDefinition.length) {
                (function(button) {
                    $scope.$watch(function() {
                        return button.condition ? button.condition() : true;
                    }, function(newValue, oldValue) {
                        if(newValue != oldValue) {
                            noChangedCondition = false;
                        }
                    });
                })($scope.buttonDefinition[i]);
                i++;
            }

            ctrl.recalcButtons = function() {
                $scope.toolbarButtons = [];
                $scope.dropDownButtons = [];
                //- 60 for the dropdown button, -165 for delete selection button, -104 are the toggle buttons for sidebar
                var totalWidth = angular.element("#ix-md-dialog-toolbar").width() - 60 - 165 - 104;
                var currUsedWidth = 0;
                var i = 0;
                while(i < $scope.buttonDefinition.length) {
                    var currentButton = $scope.buttonDefinition[i];
                    if((!currentButton.condition || currentButton.condition()) && (!currentButton.process || $securityManager.isProcessAllowed(currentButton.process))) {
                        //104 is the min width of a button. 12 is the total padding, 16 is the total margin
                        currUsedWidth += Math.max(104, ctrl.getWidthOfText(currentButton.label ? currentButton.label : currentButton.labelFunction(), 'Roboto, "Helvetica Neue", sans-serif;', '14px', '600', '.01em') + 12 + 16);
                        if(currUsedWidth >= totalWidth) {
                            break;
                        }
                        $scope.toolbarButtons.push(currentButton);
                    }
                    i++;
                }
                while(i < $scope.buttonDefinition.length) {
                    var currentButton = $scope.buttonDefinition[i];
                    if((!currentButton.condition || currentButton.condition()) && (!currentButton.process || $securityManager.isProcessAllowed(currentButton.process))) {
                        $scope.dropDownButtons.push($scope.buttonDefinition[i]);
                    }
                    i++;
                }
            };

            ctrl.getWidthOfText = function(txt, fontname, fontsize, fontweight, letterspacing) {
                var e = document.createElement('span');
                e.style.fontSize = fontsize;
                e.style.fontFamily = fontname;
                e.style.fontWeight = fontweight;
                e.style.letterSpacing = letterspacing;
                e.innerHTML = txt.toUpperCase();
                document.body.appendChild(e);
                var w = e.offsetWidth;
                document.body.removeChild(e);
                return w;
            };


            $scope.$watch(function() {
                return angular.element("#ix-md-dialog-toolbar").width();
            }, function(newValue, oldValue) {
                if(newValue != oldValue && $scope.data) {
                    ctrl.recalcButtons();
                }
            });

            $window.onresize = function() {
                if($scope.data) {
                    ctrl.recalcButtons();
                    $timeout(function() {
                        $scope.$evalAsync();
                    });
                }
            };

            $scope.$watch(function() {
                if(noChangedCondition) return;
                noChangedCondition = true;
                $scope.$$postDigest(function() {
                    if($scope.data) {
                        $scope.$evalAsync(function() {
                            ctrl.recalcButtons();
                        })
                    }
                });
            });

            $scope.$on('$destroy', function() {
                $window.onresize = null;
            });

            buttonDefinitionWatcher();
        }
    });
}